import React from 'react';
import styled from 'styled-components';
import Tippy from '@tippy.js/react';
import { HelpSolid } from '@core-ds/icons/24';
import 'tippy.js/themes/light-border.css';

const grey = '#757778';

const Tooltip = styled(Tippy)`
   padding: 7px 15px;
   border-radius: 0;

   div {
      color: ${grey};
      text-align: left;
   }
`;

const NoticeContainer = styled.div`
   color: ${grey};
   display: flex;
   align-items: center;

   :focus {
      outline: none;
   }
`;

const Icon = styled(HelpSolid)`
   margin: 0 3px;
`;

const ShippingFlagTooltip = ({ notice, children }) => {
   return (
      <Tooltip
         arrow
         content={children}
         duration={200}
         interactive
         placement="bottom"
         theme="light-border"
      >
         <NoticeContainer>
            <p>{_js(notice)}</p>
            <Icon />
         </NoticeContainer>
      </Tooltip>
   );
};

export default ShippingFlagTooltip;
